module.exports = __webpack_public_path__ + "static/media/Tribus.b033ab81.md";